import { type ComponentPropsWithoutRef, memo } from 'react';

import { type PublicClip } from '@air/api';
import { getFilename } from '@air/component-file-extension-preview';
import { Tooltip } from '@air/primitive-tooltip';
import { type Clip } from '@air/types';
import { cn } from '@air/utils-tailwind';

export type GalleryFileTitleProps = Omit<ComponentPropsWithoutRef<'button'>, 'children'> & {
  file: Clip | PublicClip;
};

export const GalleryFileTitle = memo(({ className, file, ...restOfProps }: GalleryFileTitleProps) => {
  const title = getFilename(file);

  return (
    <Tooltip label={title} side="top" sideOffset={4}>
      <button
        data-testid="FILE_CARD_TITLE"
        className={cn(
          'pointer-events-auto line-clamp-2 text-left font-medium text-16 text-grey-12 outline-none hover:underline focus-visible:ring-2 focus-visible:ring-blue-9',
          className,
        )}
        {...restOfProps}
      >
        {title}
      </button>
    </Tooltip>
  );
});

GalleryFileTitle.displayName = 'GalleryFileTitle';
